export default "__VITE_ASSET__f43ca75c__"